<!-- <html>
  <head>
    <title>reCAPTCHA demo: Simple page</title>
    <script src='https://www.google.com/recaptcha/api.js?onload=recaptchaOnload&render=explicit' async defer></script>
  </head>

</html> -->
<div class="modal-body">
  <div class="modal-header">
      <h4 class="modal-title ">Change Password</h4>
      <!-- <i class="fa fa-lock" aria-hidden="true"></i> -->
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="closeModal()">&times;</span>
        </button>
  </div>
  <!-- <spinner [id]="'loginid'" [show]='activespineer'></spinner> -->
  <div class="modal-body p-0">
    
    <form (submit)="handleChangePassword()" class="login-container" [formGroup]="passwordForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group inner-addon right-addon">
            <label class="">Current Password</label>
            <a (click)="showcurrentPassword()">
              <i [class]="show_eye ? 'fa fa-eye-slash eye_icon' : 'fa fa-eye eye_icon'"></i>
            </a>
            <!-- <input appAlphabetsWithdot [(ngModel)]="UserData['login']" name="User Name" (input)="validateOnchange('login')" type="text" placeholder="{{'header.userName' | translate}}" class="form-control custom-selectbox" autocomplete="off"> -->
            <input type="text" (keyup)="checkValidation($event)"  appNotAllowSpaces [type]="show_eye ? 'text' : 'password'" [ngClass]="hasError('currentPassword') ? 'border-danger' : ''" name="currentPassword"
            formControlName="currentPassword"class="form-control custom-selectbox "  id="currentPassword" placeholder="Enter Current Password" autocomplete="off">
            <p id="warning" style="display:none; color:red">
              Warning: CapsLock is On!
          </p>
            <!-- <span style="color:red" [hidden]="validation['login']">Please Enter User Name</span> -->
          </div>
        </div>
        <div class="col-12">
          <div class="form-group inner-addon right-addon ">
            <label class="">New Password</label>
            <a (click)="shownewPassword()">
              <i [class]="showneweye ? 'fa fa-eye-slash eye_icon' : 'fa fa-eye eye_icon'"></i>
            </a>
            <input type="text" (keyup)="newpassValidation($event)" appNotAllowSpaces [type]="showneweye ? 'text' : 'password'"
             [(ngModel)]="UserData['password']" (input)="pswdValidate(UserData['password'],'password')" 
             [ngClass]="hasError('newPassword') ? 'border-danger' : ''" name="newPassword"
            formControlName="newPassword" class="form-control custom-selectbox " id="newPassword" 
            placeholder="Enter New Password" autocomplete="off">
            <span style="color:red" [hidden]="!showerrorpwd">{{'userManagement.Weak Password' | translate}}</span>
            <p id="warn" style="display:none; color:red">
              Warning: CapsLock is On!
            </p>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group inner-addon right-addon">
            <label class="">Confirm New Password</label>
            <a (click)="showconfirmnewpsd()">
              <i [class]="showeye ? 'fa fa-eye-slash eye_icon' : 'fa fa-eye eye_icon'"></i>
            </a>
            <input type="text" (keyup)="cnfrmnewpassValidation($event)" appNotAllowSpaces
             [type]="showeye ? 'text' : 'password'" [(ngModel)]="UserData['confirmpassword']" 
             (input)="pswdValidate(UserData['confirmpassword'],'confirm')" 
             [ngClass]="hasError('confirmNewPassword') ? 'border-danger' : ''" name="confirmNewPassword"
            formControlName="confirmNewPassword" class="form-control custom-selectbox" id="confirmNewPassword" 
            placeholder="Enter New Password Again" autocomplete="off">
            <span style="color:red" [hidden]="!showerrorpwd">{{'userManagement.Weak Password' | translate}}</span>
            <p id="warned" style="display:none; color:red">
              Warning: CapsLock is On!
          </p>
           </div>
          </div>
          <div class="col-12">
            <label for="Submit" class="col-sm-4"></label>
            <div class="col-sm-8">
              <input type="submit" class="btn btn-info"  value="{{context}} Password">
            </div>
          </div>

      </div>        
    </form>
  </div>
</div>